import React from "react";
import styled from "styled-components";
import Component from '../Component'
import filterString from '../common3/filterString'
import Link from '../common3/Link'


const StyledBase = styled(Component)`
  text-align: ${p => p.textAlign};
  color: ${p => p.inlineStyle ? p.inlineStyle.color : 'inherit' };
  font-family: ${p => p.inlineStyle ? p.inlineStyle.fontFamily : 'inherit' };
  font-size: ${p => p.inlineStyle ? p.inlineStyle.fontSize + p.inlineStyle.fontSizeUnit : 'inherit' };
  line-height: ${p => p.inlineStyle ? p.inlineStyle.lineHeight + p.inlineStyle.lineHeightUnit : 'inherit' };
  ${p=>p.inlineCSS}
`;

const Heading = (props) => {
  const { extra = {}, theme={} } = props;
  const { label = 'test', tagName = 'h1',textAlign ='left', style, isLink = false, to = {}, className : inlineClassName  } = extra;

  const inlineStyle = theme[tagName.toLowerCase()]

  return (
    <StyledBase as={tagName} inlineStyle={{...inlineStyle,...style}} inlineCSS={extra.css} tagName={tagName} className={`heading ${inlineClassName ? inlineClassName :''}`} textAlign={textAlign}>
      {
        // 20220317 mh: Added effect to Link (was missing) and context
        isLink ? <Link to={to} effects={props.effects} context={props}>{filterString(label,props,props)}</Link> : filterString(label,props,props)
      }
    </StyledBase>
  );
};

export default Heading